import React, { useEffect } from 'react';
import { ChevronRight, Phone, ShoppingCart, MousePointer, CreditCard, Package, HelpCircle } from 'lucide-react';
export function HowToOrderPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-565">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-566">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-567">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-568">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-569">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-570" />
            <a href="#/support" className="hover:text-gold transition-colors" data-id="element-571">
              Support
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-572" />
            <span className="text-charcoal font-medium" data-id="element-573">How to Order</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-574">
            How to Order
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-575">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-576">
          {/* Main Content */}
          <div className="lg:w-2/3 space-y-8" data-id="element-577">
            {/* Intro */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-578">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-579">
                Ordering is Simple
              </h2>
              <p className="text-warmGray leading-relaxed text-lg" data-id="element-580">
                Start by choosing a category for the theme or decorating idea
                you are looking for. Clicking a category will result in the
                pictures for that category being displayed. Clicking on a
                picture will either display a larger image or, with the newer
                pictures, a layout of the design shown in a variety of
                configurations available. Here you can choose the size or
                configuration you need from a drop down box located to the right
                of the picture.
              </p>
            </div>

            {/* Step-by-step */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-581">
              <h2 className="text-2xl font-serif text-charcoal mb-8" data-id="element-582">
                Step-by-Step Guide
              </h2>
              <div className="space-y-8" data-id="element-583">
                {/* Step 1 */}
                <div className="flex gap-5" data-id="element-584">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center" data-id="element-585">
                    <MousePointer className="w-5 h-5 text-gold" data-id="element-586" />
                  </div>
                  <div data-id="element-587">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-588">
                      1. Select Your Size
                    </h3>
                    <p className="text-warmGray leading-relaxed" data-id="element-589">
                      Just click on the arrow and all sizes available for that
                      design will be displayed. Select the size needed so it is
                      displayed in the window and then click ADD TO CART which
                      is just below the drop down box. Your selection is now in
                      the shopping cart. Selections are placed into your
                      shopping cart and can be modified, if needed, during
                      checkout.
                    </p>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="flex gap-5" data-id="element-590">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center" data-id="element-591">
                    <ShoppingCart className="w-5 h-5 text-gold" data-id="element-592" />
                  </div>
                  <div data-id="element-593">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-594">
                      2. Continue or Checkout
                    </h3>
                    <p className="text-warmGray leading-relaxed" data-id="element-595">
                      Choose CONTINUE SHOPPING to go back and select additional
                      designs or choose CHECKOUT to finish shopping.
                    </p>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="flex gap-5" data-id="element-596">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center" data-id="element-597">
                    <CreditCard className="w-5 h-5 text-gold" data-id="element-598" />
                  </div>
                  <div data-id="element-599">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-600">
                      3. Sign In &amp; Pay
                    </h3>
                    <p className="text-warmGray leading-relaxed" data-id="element-601">
                      Choosing CHECKOUT will take you to a secured account login
                      page where you can sign in as a returning customer or log
                      in as a new customer. Returning customers will login and
                      then be directed to a payment page where you will enter
                      your credit card information. New customers will be
                      required to create an account at this point.
                    </p>
                  </div>
                </div>

                {/* Step 4 */}
                <div className="flex gap-5" data-id="element-602">
                  <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center" data-id="element-603">
                    <Package className="w-5 h-5 text-gold" data-id="element-604" />
                  </div>
                  <div data-id="element-605">
                    <h3 className="font-bold text-charcoal mb-2" data-id="element-606">
                      4. Confirm Your Order
                    </h3>
                    <p className="text-warmGray leading-relaxed" data-id="element-607">
                      From there you will confirm all of the information in your
                      order such as Special Shipping Instructions and other
                      Shipping Options. Failure to Confirm Special Shipping
                      Instructions could result in the order being shipped to
                      the individual placing the order rather than to another
                      address.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Special Instructions */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-608">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-609">
                Special Instructions During Checkout
              </h2>
              <p className="text-warmGray leading-relaxed mb-5" data-id="element-610">
                During CHECKOUT you can also specify Special Instructions such
                as: Special Address Information; Gift Certificate Information;
                special switchplate needs such as a double sized plate with the
                left switch hole blanked out, etc. You will also choose your
                shipping method at this time.
              </p>
              <p className="text-warmGray leading-relaxed" data-id="element-611">
                Once PROCESS ORDER is clicked your order is on its way.
              </p>
            </div>

            {/* Prefer to Call */}
            <div className="bg-charcoal text-cream p-8 md:p-10 rounded-sm" data-id="element-612">
              <div className="flex items-start gap-4" data-id="element-613">
                <div className="flex-shrink-0 w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center" data-id="element-614">
                  <HelpCircle className="w-6 h-6 text-gold" data-id="element-615" />
                </div>
                <div data-id="element-616">
                  <h3 className="text-xl font-serif text-white mb-3" data-id="element-617">
                    Uneasy About Ordering Online?
                  </h3>
                  <p className="text-cream/80 leading-relaxed mb-5" data-id="element-618">
                    You can simply write down the information such as item
                    numbers, sizes and quantity and then call us at our toll
                    free number shown below.
                  </p>
                  <p className="font-bold text-white text-sm uppercase tracking-wider mb-2" data-id="element-619">
                    For More Information
                  </p>
                  <a href="tel:13046863170" className="inline-flex items-center gap-2 text-2xl font-serif text-gold hover:text-gold-light transition-colors" data-id="element-620">
                    <Phone size={20} data-id="element-621" />
                    1-304-686-3170
                  </a>
                  <p className="text-cream/60 text-sm mt-2" data-id="element-622">
                    Monday–Friday, 9AM–5PM EST
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-623">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-624">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-625">
                Quick Steps
              </h4>
              <ol className="space-y-4 text-sm text-warmGray" data-id="element-626">
                <li className="flex items-start gap-3" data-id="element-627">
                  <span className="w-6 h-6 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-628">
                    1
                  </span>
                  <span data-id="element-629">Browse categories and select a design</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-630">
                  <span className="w-6 h-6 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-631">
                    2
                  </span>
                  <span data-id="element-632">
                    Choose size from the dropdown and click Add to Cart
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-633">
                  <span className="w-6 h-6 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-634">
                    3
                  </span>
                  <span data-id="element-635">Continue shopping or proceed to Checkout</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-636">
                  <span className="w-6 h-6 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-637">
                    4
                  </span>
                  <span data-id="element-638">Sign in or create an account</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-639">
                  <span className="w-6 h-6 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-640">
                    5
                  </span>
                  <span data-id="element-641">Confirm details and process your order</span>
                </li>
              </ol>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-642">
                <h4 className="font-serif text-lg text-charcoal mb-4" data-id="element-643">
                  Helpful Links
                </h4>
                <ul className="space-y-3" data-id="element-644">
                  <li data-id="element-645">
                    <a href="#/size-chart" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-646">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-647" />
                      Size Chart
                    </a>
                  </li>
                  <li data-id="element-648">
                    <a href="#/shipping" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-649">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-650" />
                      Shipping Information
                    </a>
                  </li>
                  <li data-id="element-651">
                    <a href="#/returns" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-652">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-653" />
                      Returns &amp; Exchanges
                    </a>
                  </li>
                  <li data-id="element-654">
                    <a href="#/custom-orders" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-655">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-656" />
                      Custom Orders
                    </a>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-657">
                <p className="text-sm text-warmGray mb-2 uppercase tracking-wider font-bold" data-id="element-658">
                  Need Help?
                </p>
                <a href="tel:13046863170" className="text-2xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-659">
                  304.686.3170
                </a>
                <p className="text-xs text-warmGray mt-1" data-id="element-660">
                  Mon–Fri, 9AM–5PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}